module.exports = __webpack_public_path__ + "img/zixun.89f54c2c.png";